export default __webpack_public_path__ + "static/media/login.8ec90aaa.png";